import _ from "lodash";
import { messageEnumsConsts } from "./consts";
import ACLStore from "lib/aclStore";
import { messages } from "../messages";

export const isMessagePermissioned = key => {
  switch (key) {
    case messageEnumsConsts.VALENTINE_MESSAGE:
      return ACLStore.can("FeatureFlag:ValentineMessage");
    default:
      return true;
  }
};

export const getAppropriateMessageEnum = ({ messageEnums, eventEnum }) => {
  if (eventEnum) {
    return eventEnum;
  }

  const messageEnumKeys = _.map(
    _.filter(messageEnums, messageEnum => messageEnum.appType === "WEB"),
    messageEnum => messageEnum.messageType
  );
  const messageKeys = _.map(messages, message => message.key);
  const unseenKeys = _.difference(messageKeys, messageEnumKeys);

  const permissionedUnseenKeys = _.filter(unseenKeys, key =>
    isMessagePermissioned(key)
  );

  if (_.isEmpty(permissionedUnseenKeys)) {
    return null;
  }

  const selectedMessageKey = _.first(unseenKeys);
  return selectedMessageKey;
};

export const getMessageEnumContent = key => {
  const message = _.find(messages, each => each.key === key);

  if (!message) {
    return {
      key: null,
      content: null,
    };
  }

  return message;
};

export const getMessageFromEnums = ({ messageEnums, eventEnum }) => {
  const selectedMessageEnum = getAppropriateMessageEnum({
    messageEnums,
    eventEnum,
  });
  return getMessageEnumContent(selectedMessageEnum);
};
